module.exports = __webpack_public_path__ + "img/coming-soon.ec74165c.png";